import { Box, Typography } from "@material-ui/core";
import Skeleton from "@material-ui/lab/Skeleton";

interface LoadingProps {
  width?: number | "auto";
}

const CardLoading = ({ width }: LoadingProps): JSX.Element => (
  <Box height={100} width={width ?? 1} p={2} display="flex" flexDirection="column">
    <Box display="flex" width={1}>
      <Skeleton animation="wave" variant="circle" width={40} height={35} />
      <Box width={1} ml="10px" display="flex" flexDirection="column" justifyContent="center">
        <Skeleton animation="wave" variant="text" width="30%" height="10px" />
        <Skeleton animation="wave" variant="text" width="20%" height="10px" />
      </Box>
    </Box>
    <Box display="flex" flexDirection="column" width={1} mt={3}>
      <Typography variant="body1">
        <Skeleton animation="wave" variant="text" width="80%" height="10px" />
      </Typography>
      <Typography variant="body1">
        <Skeleton animation="wave" variant="text" width="90%" height="10px" />
      </Typography>
      <Typography variant="body1">
        <Skeleton animation="wave" variant="text" width="40%" height="10px" />
      </Typography>
    </Box>
  </Box>
);

export default CardLoading;
